import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './layouts/full/breadcrumb/breadcrumb.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';

import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './shared/spinner.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { GlobalProvider } from './global-provider.component';
import { DialogCambioTiendaComponent } from './layouts/full/header/dialog-cambio-tienda.component';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { Calendar } from './calendar';
import { BnNgIdleService } from 'bn-ng-idle';
import { HeaderUtil } from './utils/clases/headerUtil';
import { HttpRequestUtils } from './utils/clases/httpRequestUtil';
import { ExcepcionesUtil } from './utils/clases/excepcionesUtil';
import { SnackBarUtils } from './utils/clases/snackBarUtils';
import { PaginacionUtil } from './utils/clases/valoresPaginacionUtil';
import { LocalStorageUtils } from './utils/clases/localStorageUtil';
import { AppFooterComponent } from './layouts/full/footer/footer.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SpinnerService } from './service/spinner.service';
import { ComponentsModule } from './components/components.module';

import localeEs from "@angular/common/locales/es";
import { registerLocaleData } from "@angular/common";
registerLocaleData(localeEs, "es");

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    wheelSpeed: 2,
    wheelPropagation: true
};

@NgModule({
    declarations: [
        AppComponent,
        FullComponent,
        AppHeaderComponent,
        SpinnerComponent,
        AppSidebarComponent,
        LoginComponent,
        AppBreadcrumbComponent,
        DialogCambioTiendaComponent,
        AppFooterComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        CommonModule,
        DemoMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        PerfectScrollbarModule,
        HttpClientModule,
        SharedModule,
        CdkTableModule,
        ComponentsModule,
        RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' })
    ],
    providers: [
        AuthGuard,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: LOCALE_ID, useValue: "es" },
        GlobalProvider,
        HeaderUtil,
        Calendar,
        BnNgIdleService,
        HttpRequestUtils,
        ExcepcionesUtil,
        SnackBarUtils,
        PaginacionUtil,
        LocalStorageUtils,
        SpinnerService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
